import { Relays } from 'constants/Relays';
import { GetRelay, SetRelay, useRelay } from 'phoenix/hooks/UseRelay';

export const usePageNotFound = () => useRelay(Relays.PageNotFound)
export const SetPageNotFound = (flag: boolean) => SetRelay(Relays.PageNotFound, flag)
export const GetPageNotFound = () => GetRelay(Relays.PageNotFound)